'use client';

// import { useTranslations } from "next-intl";

// import Error from 'next/error';

// Note that `app/[locale]/[...rest]/page.tsx` is necessary for this page to render.
export default function NotFound() {
	return (
		<section>
			<div className="container">
				{/* <Error statusCode={404} /> */}
				<h1>Not Found</h1>
				<p>Deze pagina bestaat niet (meer).</p>
			</div>
		</section>
	);
}
